import React, { useState } from 'react';
import {
  G2,
  Chart,
  Geom,
  Axis,
  Tooltip,
  Coord,
  Label,
  Legend,
  View,
  Guide,
  Shape,
  Facet,
  Util,
} from 'bizcharts';
import DataSet from '@antv/data-set';
import Slider from 'bizcharts-plugin-slider';
import router from 'umi/router';
import moment from 'moment';
import { connect } from 'dva';
import { DateOfDays } from './Utils/DateOfDays';
import { getHistoricalDate } from '../../../../utils/getHistoricalDate';
import { awsData } from './RisksDummyData';
import { MapToObject } from './Utils/MapToObject';


const HealthChart = props => {
  let hoverDate;

  // const [hoverDate, setHoverDate] = useState()
  let { appliedFilters, dispatch, noOfRisk } = props;
  const { risks } = props;
  //Dynamic Risk Generate According to the date

  const handleHistoryChange = e => {
    dispatch({
      type: 'universalDrawer/saveSelectedDate',
      payload: {
        selectedDate: e,
      },
    });

    appliedFilters = appliedFilters.filter(v => v.type !== 'history');

    if (e) {
      let date = getHistoricalDate(e);
      let historyFilter = {
        type: 'history',
        value: [date.endTime],
      };
      appliedFilters.push(historyFilter);
    }
    applyFilter(appliedFilters);
  };

  const applyFilter = rules => {
    let rulesStringify = JSON.stringify(rules);
    const url = window.location.search;
    let modifiedUrl = url.replace(/(filters=)[^\&]+/, `$1${  rulesStringify}`);
    router.push(modifiedUrl);
  };

  const dates = DateOfDays(moment(), 7);

  // TODO: Update Risks by Firebase Function

  const data = noOfRisk;

  const ds = new DataSet({
    state: {
      start: 0,
      end: 1,
    },
  });

  const handleSliderChange = e => {
    const { startRadio, endRadio } = e;
    ds.setState('start', startRadio);
    ds.setState('end', endRadio);
  };

  const cols2 = {
    risk: {
      min: 0,
      type: 'linear',
    },
    date: {
      range: [0, 1],
    },
  };
  const dv = ds.createView('origin').source(data);
  dv.transform({
    type: 'filter',
    callback(item, idx) {
      const radio = idx / data.length;
      return radio >= ds.state.start && radio <= ds.state.end;
    },
  });

  const handleEvent = ev => {
    const {title} = ev.items[0];
    hoverDate = title;
    // setHoverDate(title)
  };

  return (
    <>
      <Chart
        height={150}
        padding="auto"
        data={dv}
        scale={cols2}
        forceFit
        onPlotClick={() => handleHistoryChange(hoverDate)}
        onTooltipChange={handleEvent}
      >
        <Axis
          name="date"
          visible={true}
          label={{
            formatter: val => {
              // * we have date in format 12 Dec 2022
              // * we need to return only 12 Dec
              return val
                .split(' ')
                .slice(0, 2)
                .join(' ');
            },
          }}
        />
        <Axis name="risk" />
        <Tooltip
          crosshairs={{
            type: 'y',
          }}
        />
        {/* <Geom type="interval" position="date*risk" /> */}
        <Geom
          type="area"
          opacity={0.85}
          shape="smooth"
          color="l(100) 0:#3AA0FF73 1:#3AA0FF00"
          position="date*risk"
        />
        {/* <Geom
          type="line"
          color="#90CAFF"
          position="date*risk"
          shape="smooth"
          size={2}
          tooltip={false}
        /> */}
      </Chart>
      {/* <Slider data={data} padding={80} xAxis="date" yAxis="risk" onChange={handleSliderChange} /> */}
    </>
  );
};

export default connect(({ universalDrawer }) => ({
  appliedFilters: universalDrawer.appliedFilters,
}))(HealthChart);
